import React, {useState} from 'react';

const useSelect = (stateInit, opciones) => {

	// state
	const[state, saveState] = useState(stateInit);

	const SelectNews = () => (
		<select
			className="browser-default"
			value={state}
			onChange={e => saveState(e.target.value)}
		>
			{opciones.map(option => (
			<option key={option.value}value={option.value}>{option.label}</option>
			))}
		</select>
	);

	return [state, SelectNews];
}

export default useSelect;